import React from "react";
import LogoMark from "@/components/LogoMark";

const ITEMS = [
  "من أرض فلسطين", "إلى مائدتك", "جودة من أرضنا", "موسم الزيتون",
  "بصمة الأرض", "مونة البيت", "زيت يُعصر على البارد", "زعتر من التلال",
];

export default function Marquee() {
  return (
    <div data-testid="editorial-marquee" dir="ltr" aria-hidden="true"
      className="overflow-hidden border-y border-olive/10 bg-ivory py-5">
      <div className="marquee-track flex w-max">
        {[0, 1].map((copy) => (
          <div key={copy} className="flex shrink-0 items-center">
            {ITEMS.map((it, i) => (
              <span key={i} className="flex items-center">
                <span dir="rtl" className="whitespace-nowrap px-8 font-display text-xl font-semibold text-olive-dark/70 sm:text-2xl">{it}</span>
                <LogoMark className="h-4 w-4 shrink-0 text-earth/70" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
